function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg092CaymanIslands(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.002,
    y: 0.002,
    style: {
      fill: "#2E52B2"
    },
    width: 511.998,
    height: 511.998
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#6DA544"
    },
    cx: 383.998,
    cy: 181.793,
    r: 29.681
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.053,
    y: 174.38,
    style: {
      fill: "#D80027"
    },
    width: 103.88,
    height: 44.522
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#496E2D"
    },
    d: "M435.94,255.999v-0.001V255.999z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M332.056,285.68v29.681h15.616c9.364,9.176,22.18,14.84,36.326,14.84  c14.147,0,26.962-5.664,36.326-14.84h0.776h14.84V285.68H332.056z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#338AF3"
    },
    d: "M332.056,211.477v44.522c0,39.759,51.942,51.942,51.942,51.942s51.942-12.182,51.942-51.942v-44.522  H332.056z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3F3F3"
    },
    d: "M383.995,235.259c-12.985,0-12.985,11.873-25.969,11.873c-12.985,0-12.985-11.873-25.969-11.873   v20.777c12.985,0,12.985,11.873,25.969,11.873c12.985,0,12.985-11.873,25.969-11.873c12.986,0,12.986,11.873,25.973,11.873   c12.986,0,12.986-11.873,25.973-11.873v-20.777c-12.986,0-12.986,11.873-25.973,11.873   C396.982,247.131,396.982,235.259,383.995,235.259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3F3F3"
    },
    d: "M383.995,193.669c-12.985,0-12.985,11.873-25.969,11.873c-12.985,0-12.985-11.873-25.969-11.873   v20.777c12.985,0,12.985,11.873,25.969,11.873c12.985,0,12.985-11.873,25.969-11.873c12.986,0,12.986,11.873,25.973,11.873   c12.986,0,12.986-11.873,25.973-11.873v-20.777c-12.986,0-12.986,11.873-25.973,11.873   C396.982,205.542,396.982,193.669,383.995,193.669z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "255.999,0 255.999,48.896 215.852,89.043 255.999,89.043 255.999,166.956 203.463,166.956   255.999,219.491 255.999,255.999 232.28,255.999 166.956,190.664 166.956,255.999 89.043,255.999 89.043,178.275 11.331,255.999   0,255.999 0,207.103 40.147,166.956 0,166.956 0,89.043 52.535,89.043 0,36.508 0,0 23.719,0 89.043,65.335 89.043,0 166.956,0   166.956,77.723 244.668,0 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "0,152 104,152 104,255.999 152,255.999 152,152 255.999,152 255.999,104 152,104 152,0   104,0 104,104 0,104 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "166.956,166.956 255.999,255.999 255.999,230.819 192.136,166.956 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "166.956,166.956 255.999,255.999 255.999,230.819 192.136,166.956 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "166.956,166.956 255.999,255.999 255.999,230.819 192.136,166.956  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "63.862,166.958 0,230.82 0,255.999 0,255.999 89.041,166.958  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "89.043,89.043 0,0 0,25.18 63.863,89.043 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "89.043,89.043 0,0 0,25.18 63.863,89.043 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "89.043,89.043 0,0 0,25.18 63.863,89.043  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "192.137,89.041 255.999,25.179 255.999,0 255.999,0 166.958,89.041  "
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg092CaymanIslands);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };